import { getExplorerBaseUrlForChain } from "@/chains";

export function getExplorerBaseUrl(chainId: number): string {
  return getExplorerBaseUrlForChain(chainId);
}

export function blockscoutFetch(explorerBaseUrl: string, path: string): Promise<Response> {
  const url = `${explorerBaseUrl}${path}`;
  return fetch(url);
}

export function truncateAddress(address: string): string {
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

export function formatDeploymentDate(isoTimestamp: string): string {
  return new Date(isoTimestamp).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
